"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentedControl = void 0;
var tslib_1 = require("tslib");
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var theme_1 = require("../../theme");
var colors_1 = require("../../theme/colors");
var flexbox_1 = require("../flexbox");
var text_1 = require("../text");
function SegmentedControl(props) {
    var options = props.options, value = props.value, onChange = props.onChange, _a = props.fluid, fluid = _a === void 0 ? false : _a, _b = props.style, style = _b === void 0 ? {} : _b, _c = props.fontWeight, fontWeight = _c === void 0 ? 600 : _c, _d = props.activeColor, activeColor = _d === void 0 ? 'active' : _d, _e = props.variant, variant = _e === void 0 ? 'regular' : _e;
    var _f = props.inactiveColor, inactiveColor = _f === void 0 ? variant === 'thin' ? colors_1.colors.steel[400] : 'dark' : _f;
    var containerClassName = (0, classnames_1.default)({
        fluid: fluid,
    });
    var items = options.map(function (option) {
        var isActive = value === option.value;
        var className = (0, classnames_1.default)({
            isActive: isActive,
            fluid: fluid,
        });
        return (react_1.default.createElement(StyledOption, { key: option.value, "data-testid": "segmentedcontrol:option:".concat(option.value), className: className, onClick: function () { return onChange(option.value); }, role: "checkbox", "aria-checked": isActive, tabIndex: 0, onKeyDown: function (e) {
                if (e.key === ' ') {
                    onChange(option.value);
                }
            }, variant: variant, hasIcon: !!option.icon },
            option.icon && (react_1.default.createElement("div", null, react_1.default.cloneElement(option.icon, {
                size: 24,
                color: isActive ? activeColor : inactiveColor,
            }))),
            !option.icon && option.label && (react_1.default.createElement(text_1.Text, { color: isActive ? activeColor : inactiveColor, weight: fontWeight, textAlign: "center" }, option.label))));
    });
    return (react_1.default.createElement(StyledDiv, { className: containerClassName, style: style, variant: variant },
        react_1.default.createElement(flexbox_1.Flexbox, { flexWrap: "wrap" }, items)));
}
exports.SegmentedControl = SegmentedControl;
var StyledDiv = styled_components_1.default.div(function (_a) {
    var variant = _a.variant;
    return "\n  border: 1px solid #dbdbdb;\n  border-radius: ".concat(variant === 'thin' ? 4 : 3, "px;\n  display: inline-block;\n  height: ").concat(variant === 'thin' ? 24 : 40, "px;\n  box-sizing: border-box;\n  width: max-content;\n\n  &.fluid {\n    width: 100%;\n  }\n");
});
var StyledOption = styled_components_1.default.div(function (_a) {
    var variant = _a.variant, hasIcon = _a.hasIcon;
    return "\n  padding: ".concat(hasIcon ? "7px 16px" : variant === 'thin' ? '0px 16px 1px 16px' : '8px 16px 9px', ";\n\n  border-right: 1px solid #dbdbdb;\n  cursor: pointer;\n  display: flex-box;\n  align-items: center;\n  justify-content: center;\n\n  :last-child {\n    border-right: none;\n  }\n\n  &.fluid {\n    flex: 1;\n  }\n\n  &.isActive {\n    background-color: ").concat(theme_1.colors.primary_xxxl, ";\n  }\n");
});
//# sourceMappingURL=index.js.map